import { Dismissal } from '../types/content'

/** The four sentences almost every woman in this audience has been told. */
export const dismissals: Dismissal[] = [
  {
    said: 'You’re too young for that.',
    truth:
      'Perimenopause commonly begins in the early forties and can start in the mid-thirties. Age is not a diagnostic test, and being told you are too young has kept women untreated for an average of several years.',
  },
  {
    said: 'Your bloods came back normal.',
    truth:
      'In perimenopause, hormone levels swing so widely that a single blood draw tells you what was happening that morning and almost nothing else. A normal FSH result does not rule out perimenopause. Diagnosis is clinical — it is made from your symptoms and cycle history.',
  },
  {
    said: 'It’s probably just stress.',
    truth:
      'Stress does not usually arrive as hot flushes at 3am, joint pain in both hands, and a seven-day change in your cycle length. When several systems shift at once in your forties, hormones deserve to be considered before your life is blamed.',
  },
  {
    said: 'This is just part of being a woman.',
    truth:
      'Some of it is a normal transition. Almost none of it has to be endured untreated. Hot flushes, sleep loss, mood change, painful sex and recurrent UTIs all have effective, evidence-based treatments that most women are never offered.',
  },
]
